<template>
  <div class="pcm-b-wrapper" id="pcm-b-wrapper">
    <div class="pcm-b-stage">
      <div class="pcm-b-carousel" aria-hidden="true">
        <div
          v-for="(slide, i) in slides"
          :key="i"
          class="pcm-b-slide"
          :class="[`pcm-b-slide-${i + 1}`, { active: i === index }]"
        >
          <img class="pcm-b-gallery" :src="slide.gallery" alt="" />
          <img class="pcm-b-hero" :src="slide.hero" alt="" />
        </div>
      </div>

      <div class="pcm-b-fruit" aria-hidden="true"></div>
      <div
        class="pcm-b-title"
        :class="`pcm-b-title-${index + 1}`"
        aria-hidden="true"
      ></div>
      <div class="pcm-b-subtitle" aria-hidden="true"></div>

      <div class="pcm-b-catalog" aria-hidden="true"></div>
      <div class="pcm-b-qr-panel" aria-hidden="true"></div>
      <div class="pcm-b-qr-code">
        <img :src="qrImg" alt="下载二维码" />
      </div>
      <button
        class="pcm-b-download pcm-b-download-android"
        type="button"
        aria-label="安卓极速版下载"
        @click="getApkInfo('android')"
      ></button>
      <button
        class="pcm-b-download pcm-b-download-ios"
        type="button"
        aria-label="苹果极速版下载"
        @click="getApkInfo('ios')"
      ></button>
      <div class="pcm-b-faq" aria-hidden="true"></div>

      <div class="pcm-b-logo" aria-hidden="true"></div>
      <div class="pcm-b-contact-list" v-if="contactItems.length">
        <button
          v-for="item in contactItems"
          :key="item.type"
          class="pcm-b-contact-button"
          :class="`pcm-b-contact-${item.type}`"
          type="button"
          :aria-label="item.label"
          @click="toContact(item.url)"
        ></button>
      </div>
    </div>
  </div>
</template>

<script>
import Gallery1 from "@/assets/images/pc1/b/gallery1.webp";
import Gallery2 from "@/assets/images/pc1/b/gallery2.webp";
import Gallery3 from "@/assets/images/pc1/b/gallery3.webp";
import Hero1 from "@/assets/images/pc1/b/hero1.webp";
import Hero2 from "@/assets/images/pc1/b/hero2.webp";
import Hero3 from "@/assets/images/pc1/b/hero3.webp";

export default {
  props: ["qrImg", "os", "configs"],
  data() {
    return {
      tgUrl: "",
      potatoUrl: "",
      swUrl: "",
      qdUrl: "",
      slides: [
        { gallery: Gallery1, hero: Hero1 },
        { gallery: Gallery2, hero: Hero2 },
        { gallery: Gallery3, hero: Hero3 },
      ],
      index: 0,
      timer: null,
      interval: 3600,
    };
  },
  computed: {
    contactItems() {
      return [
        { type: "group", label: "官方群组", url: this.tgUrl },
        { type: "business", label: "商务合作", url: this.swUrl },
        { type: "channel", label: "渠道合作", url: this.qdUrl },
      ].filter((item) => item.url);
    },
  },
  watch: {
    configs: {
      immediate: true,
      handler(newValue = []) {
        this.tgUrl = "";
        this.potatoUrl = "";
        this.swUrl = "";
        this.qdUrl = "";
        newValue.forEach((item) => {
          if (item.configType === "tg_group") {
            this.tgUrl = item.link;
          } else if (item.configType === "potato_group") {
            this.potatoUrl = item.link;
          } else if (item.configType === "sw_cooperate") {
            this.swUrl = item.link;
          } else if (item.configType === "qd_cooperate") {
            this.qdUrl = item.link;
          }
        });
      },
    },
  },
  mounted() {
    this.start();
  },
  beforeDestroy() {
    this.stop();
  },
  methods: {
    start() {
      this.stop();
      this.timer = setInterval(this.next, this.interval);
    },
    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    next() {
      this.index = (this.index + 1) % this.slides.length;
    },
    getApkInfo(type) {
      this.$emit("getApkInfo", type);
    },
    toContact(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.pcm-b-wrapper {
  background: #168eea url("../../../assets/images/pc1/b/bg.webp") no-repeat
    center;
  background-size: cover;
  height: 100vh;
  overflow: hidden;
  position: relative;
  width: 100vw;
}

.pcm-b-stage {
  aspect-ratio: 16 / 9;
  background-size: 100% 100%;
  height: min(100vh, 56.25vw);
  left: 50%;
  overflow: hidden;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: min(100vw, 177.777778vh);
}

.pcm-b-carousel,
.pcm-b-slide {
  inset: 0;
  position: absolute;
}

.pcm-b-carousel {
  z-index: 10;
}

.pcm-b-slide {
  opacity: 0;
  transform: scale(1.012);
  transition: opacity 0.9s ease, transform 3.6s ease-out;
  z-index: 1;
}

.pcm-b-slide.active {
  opacity: 1;
  transform: scale(1);
  z-index: 2;
}

.pcm-b-gallery,
.pcm-b-hero {
  display: block;
  object-fit: fill;
  pointer-events: none;
  position: absolute;
}

.pcm-b-gallery {
  z-index: 1;
}

.pcm-b-hero {
  z-index: 2;
}

.pcm-b-slide-1 .pcm-b-gallery {
  height: 84.534183%;
  left: 46.09375%;
  top: 3.611111%;
  width: 55.375208%;
}

.pcm-b-slide-1 .pcm-b-hero {
  height: 96.944444%;
  left: 40.677083%;
  top: 3.148148%;
  width: 54.53125%;
}

.pcm-b-slide-2 .pcm-b-gallery {
  height: 95.813791%;
  left: 43.697917%;
  top: -4.166667%;
  width: 60.716808%;
}

.pcm-b-slide-2 .pcm-b-hero {
  height: 94.351852%;
  left: 44.322917%;
  top: 7.037037%;
  width: 53.072917%;
}

.pcm-b-slide-3 .pcm-b-gallery {
  height: 95.813791%;
  left: 42.604167%;
  top: -0.462963%;
  width: 60.716808%;
}

.pcm-b-slide-3 .pcm-b-hero {
  height: 81.296296%;
  left: 46.041667%;
  top: 18.518519%;
  width: 45.729167%;
}

.pcm-b-fruit,
.pcm-b-title,
.pcm-b-subtitle,
.pcm-b-catalog,
.pcm-b-qr-panel,
.pcm-b-faq,
.pcm-b-logo {
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  pointer-events: none;
  position: absolute;
}

.pcm-b-fruit {
  background-image: url("../../../assets/images/pc1/b/deco-fruit.webp");
  height: 65.833333%;
  left: 34.166667%;
  top: 34.259259%;
  width: 65.833333%;
  z-index: 20;
}

.pcm-b-title {
  background-image: url("../../../assets/images/pc1/b/title1.webp");
  height: 73.148148%;
  left: 2.083333%;
  top: -2.314815%;
  width: 54.84375%;
  z-index: 30;

  &-1 {
    background-image: url("../../../assets/images/pc1/b/title1.webp");
  }
  &-2 {
    background-image: url("../../../assets/images/pc1/b/title2.webp");
  }
  &-3 {
    background-image: url("../../../assets/images/pc1/b/title3.webp");
  }
}

.pcm-b-subtitle {
  background-image: url("../../../assets/images/pc1/b/subtitle.webp");
  height: 18.044563%;
  left: 1.71875%;
  top: 46.481481%;
  width: 58.385417%;
  z-index: 31;
}

.pcm-b-catalog {
  background-image: url("../../../assets/images/pc1/b/catalog.webp");
  height: 30.078102%;
  left: 1.041667%;
  top: 64.537037%;
  width: 29.166667%;
  z-index: 40;
}

.pcm-b-qr-panel {
  background-image: url("../../../assets/images/pc1/b/qr-box.webp");
  height: 28.703704%;
  left: 28.90625%;
  top: 64.62963%;
  width: 12.712107%;
  z-index: 40;
}

.pcm-b-qr-code {
  background: #fff;
  height: 15.793704%;
  left: 30.7%;
  overflow: hidden;
  position: absolute;
  top: 70.3%;
  width: 9.008958%;
  z-index: 41;
}

.pcm-b-qr-code img {
  display: block;
  height: 100%;
  object-fit: contain;
  width: 100%;
}

.pcm-b-download {
  appearance: none;
  background-color: transparent;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border: 0;
  cursor: pointer;
  padding: 0;
  position: absolute;
  width: 18.512089%;
  z-index: 42;
}

.pcm-b-download-android {
  background-image: url("../../../assets/images/pc1/b/download-android.webp");
  height: 10.17008%;
  left: 41.5625%;
  top: 68.796296%;
}

.pcm-b-download-ios {
  background-image: url("../../../assets/images/pc1/b/download-ios.webp");
  height: 9.681917%;
  left: 41.592078%;
  top: 78.980024%;
}

.pcm-b-faq {
  background-image: url("../../../assets/images/pc1/b/faq.webp");
  height: 35.277778%;
  left: 73.854167%;
  top: 60.092593%;
  width: 24.791667%;
  z-index: 40;
}

.pcm-b-logo {
  background: url("../../../assets/images/pc1/b/logo.webp") center / contain no-repeat;
  height: 6.574074%;
  left: 8.75%;
  top: 3.333333%;
  width: 10.147603%;
  z-index: 60;
}

.pcm-b-contact-list {
  align-items: flex-start;
  display: flex;
  gap: 3.162%;
  height: 4.814815%;
  justify-content: flex-end;
  left: 64.84375%;
  position: absolute;
  top: 4.259259%;
  width: 26.02066%;
  z-index: 60;
}

.pcm-b-contact-button {
  appearance: none;
  background-color: transparent;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border: 0;
  cursor: pointer;
  flex: 0 0 31.225%;
  height: 100%;
  padding: 0;
}

.pcm-b-contact-group {
  background-image: url("../../../assets/images/pc1/b/contact-group.webp");
}

.pcm-b-contact-business {
  background-image: url("../../../assets/images/pc1/b/contact-business.webp");
}

.pcm-b-contact-channel {
  background-image: url("../../../assets/images/pc1/b/contact-channel.webp");
}
</style>
